import { useSchematicBuilderContext } from "../../SchematicBuilderContext";
import { preventDrag } from "../../util/preventDrag";

const KIND_PLACEHOLDER = "--KIND--";

export function KindSelect() {
  const { schematicKinds, useSchematic, setSchematic, parentChildName } =
    useSchematicBuilderContext();
  const kind = useSchematic((schematic) => schematic.kind);

  return (
    <select
      className="builder-input builder-schema"
      value={kind}
      onChange={(evt) => {
        const schematicKind = schematicKinds.get(evt.target.value);
        setSchematic({
          kind: evt.target.value,
          packageSuffix: schematicKind?.defaultPackageSuffix?.(
            parentChildName!,
          ),
          name: schematicKind?.defaultName?.(parentChildName!),
          collapsed: false,
          nullable: schematicKind?.nullable ?? schematicKind?.defaultNullable,
          children: schematicKind?.initChildren?.(parentChildName!),
        });
      }}
      required
      style={{
        width: `calc(${(kind || KIND_PLACEHOLDER).length}ch + 1.85rem)`,
      }}
      {...preventDrag}
    >
      <option>{KIND_PLACEHOLDER}</option>
      {Array.from(schematicKinds.values())
        .filter((kind) => !kind.internal)
        .map((kind) => (
          <option key={kind.kind} value={kind.kind}>
            {kind.kind}
          </option>
        ))}
    </select>
  );
}
